import { render, staticRenderFns } from "./CreatePlantPart.vue?vue&type=template&id=0a7b2cbe&scoped=true&"
import script from "./CreatePlantPart.vue?vue&type=script&lang=ts&"
export * from "./CreatePlantPart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b2cbe",
  null
  
)

export default component.exports